// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"749":"041e9d9c944dfa47","760":"76c73b5277071dd9","1210":"045c3591c1bf89fd","2548":"c00f41195903bd16","6734":"ff08f565e3f6e372","9136":"da029d370bee50fa","9220":"2196fe661e42dc03"}[chunkId] + ".js";
};